import { COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE } from '../actions/authMethodConfig.actions';

const initialState = {
  loginMethod: null,
  tpoLoginMethod: null,
  posLoginMethod: null,
  posSharedEmailAccounts: false,
  rememberDeviceDays: null,
};

const authMethodConfigReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE.GET_AUTH_METHOD_CONFIG:
    case COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE.UPDATE_AUTH_METHOD_CONFIG:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default authMethodConfigReducer;
